import { DatePickerField } from "@/src/components/Fields/DataPickerField";

export function DateTimeInput(props: any) {
  return <DatePickerField {...props} />;
}
